import React from 'react';
import PropTypes from 'prop-types';
import { sendToSentry } from '../libs/sentryErrorLogging';
import RefreshAction from './RefreshAction/RefreshAction';
import { OutdatedServerVersionError } from '../libs/errors';

export default class DetectServerUpdateBoundary extends React.Component {
  static currentServerVersion = 10;

  static checkServerVersionNumber = (versionNumberFromHeader) =>
    DetectServerUpdateBoundary.currentServerVersion ===
    Number.parseInt(versionNumberFromHeader);

  constructor(props) {
    super(props);
    this.state = {
      showRefreshAction: false
    };

    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  handleUnhandledRejection(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.reason instanceof OutdatedServerVersionError) {
      this.setState({ showRefreshAction: true });
    } else if (!event.reason?.handledByBoundary) sendToSentry(event);
  }

  render() {
    const { children } = this.props;
    const { showRefreshAction } = this.state;

    return (
      <>
        {showRefreshAction && <RefreshAction />}
        {children({
          ...this.props
        })}
      </>
    );
  }
}

DetectServerUpdateBoundary.propTypes = {
  children: PropTypes.func.isRequired
};

DetectServerUpdateBoundary.defaultProps = {};
